export default __webpack_public_path__ + "static/media/main-community.96c96989.jpg";